import script from "./HorseRacingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HorseRacingPage.vue?vue&type=script&setup=true&lang=js"

import "./HorseRacingPage.vue?vue&type=style&index=0&id=7ba64821&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba64821"]])

export default __exports__